import { object } from "../../helpers/object";
import { debug } from "../../helpers/debug";
import { gtm } from "../../components/gtm";
import { theme } from "../../helpers/theme";

/*------------------------------------*\
  #PRODUCT-MAIN
\*------------------------------------*/
class ProductMain {


  constructor(module){
    this.MODULE = module;
    this.DOM_MODULE = object.toArray(document.querySelectorAll(this.MODULE));
  }
  /**
   * INITIALISATION
   * @returns 
   */
  init = () => {
    if (!this.DOM_MODULE.length) return;

    this.gtm();

    if(debug.DEBUG) console.log('async/product/main.js');
  };

  /**
   * GOOGLE TAG MANAGER
   * @returns 
   */
  gtm = () => {
    const product = this.DOM_MODULE[0].querySelector('[data-product-id][data-product-name][data-product-cat]');
    if (!product) return;
    const productPrice = this.DOM_MODULE[0].querySelector('.c-product-price__value[itemprop="price"]')?.getAttribute('content') ?? 0;
    gtm.track({
      'event': 'productImpressions',
      'ecommerce': {
          'detail': {
              'actionField': {'list': theme.get()},
              'products': [{
                  'name': product.getAttribute('data-product-name'),
                  'id': product.getAttribute('data-product-id'),
                  'price': productPrice,
                  'brand': product.getAttribute('data-product-brand') ?? 'Legrand',
                  'category': product.getAttribute('data-product-cat'),
                  'variant': ''
              }]
          }
      }
    });
  }
}
export default new ProductMain('[data-js-component="product-main"]'); 
